export const FETCH_DASHBOARD_COUNT_REQUEST='FETCH_DASHBOARD_COUNT_REQUEST'
export const FETCH_DASHBOARD_COUNT_SUCCESS='FETCH_DASHBOARD_COUNT_SUCCESS'
export const FETCH_DASHBOARD_COUNT_FAILURE='FETCH_DASHBOARD_COUNT_FAILURE'

export const FETCH_DASHBOARD_USAGE_REQUEST='FETCH_DASHBOARD_USAGE_REQUEST'
export const FETCH_DASHBOARD_USAGE_SUCCESS='FETCH_DASHBOARD_USAGE_SUCCESS'
export const FETCH_DASHBOARD_USAGE_FAILURE='FETCH_DASHBOARD_USAGE_FAILURE'

export const fetchDashboardCountRequest = (payload) =>({
    type: FETCH_DASHBOARD_COUNT_REQUEST,
    payload
})
export const fetchDashboardCountSuccess = (count) =>({
    type: FETCH_DASHBOARD_COUNT_SUCCESS,
    payload:count
})
export const fetchDashboardCountFailure = (error) =>({
    type: FETCH_DASHBOARD_COUNT_FAILURE,
    payload:error
})

export const fetchDashboardUsageRequest = (payload) =>({
    type: FETCH_DASHBOARD_USAGE_REQUEST,
    payload
})
export const fetchDashboardUsageSuccess = (usage) =>({
    type: FETCH_DASHBOARD_USAGE_SUCCESS,
    payload:usage
})
export const fetchDashboardUsageFailure = (error) =>({
    type: FETCH_DASHBOARD_USAGE_FAILURE,
    payload:error
})